import React, { useState } from "react";
import { Form, Upload, Image } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const CompanyLogoUpload = ({ fileList, setFileList }) => {
  const [previewImage, setPreviewImage] = useState("");

  return (
    <>
      <Form.Item label="Company Logo" name="logo">
        <Upload
          listType="picture-card"
          accept="image/*"
          fileList={fileList}
          onChange={({ fileList: newFileList }) => {
            setFileList(newFileList);
          }}
          onPreview={async (file) => {
            const src = file.url || URL.createObjectURL(file.originFileObj);
            setPreviewImage(src);
          }}
          beforeUpload={() => false}
          maxCount={1}
        >
          {fileList.length < 1 && (
            <div>
              <UploadOutlined />
              <div style={{ marginTop: 8 }}>Upload Logo</div>
            </div>
          )}
        </Upload>
      </Form.Item>

      {previewImage && (
        <Image
          style={{ display: "none" }}
          preview={{
            open: true,
            src: previewImage,
            onOpenChange: () => setPreviewImage(""),
          }}
        />
      )}
    </>
  );
};

export default CompanyLogoUpload;
